
import React, { useState } from "react";
import { Snackbar, Card, CardContent, Typography, Button, IconButton, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { RiCloseLargeLine } from "react-icons/ri";

const SnackbarComponent = ({ message }) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = (_, reason) => {
        if (reason === "clickaway") return; // Prevent closing when clicking outside
        setOpen(false);
    };

    return (
        <>
            <Typography
                variant="h6"
                gutterBottom
              style={{ color: '#474747', fontWeight: "400", fontSize: '16px', textAlign: 'justify',marginBottom: '0px'  }}
            >
                {message} 
                {/* <span style={{ color: `${theme?.customSettings?.themeColor}`, cursor: 'pointer' }} onClick={() => setOpen(true)}>More info.</span> */}
            </Typography>
            {/* <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={open}
                onClose={handleClose}
            >
                <Card sx={{ minWidth: 300, backgroundColor: "#fff", borderRadius: 2, boxShadow: 3 }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom sx={{ color: `${theme?.customSettings?.themeColor}`, fontSize: '16px' }}>
                            Help Center
                        </Typography>
                    </CardContent>
                    <IconButton
                        sx={{ position: "absolute", top: 10, right: 10 }}
                        onClick={handleClose}
                    >
                        <RiCloseLargeLine style={{ fontSize: '20px' }} />
                    </IconButton>
                </Card>
            </Snackbar> */}
        </>
    );
};

export default SnackbarComponent;


